import styled from 'styled-components'

export const JobsWrapper = styled.section`
  max-width: 1312px;

  margin: 0 auto 112px;
  padding: 0 32px;
  position: relative;

  display: flex;
  flex-direction: column;
  align-items: center;


  p {
    text-align: center;
  }

  h3 {
    margin-bottom: 24px;
  }

  p {
    max-width: 740px;
    margin-bottom: 48px;
  }

  @media (max-width: 767px) {
    padding: 0 24px;
    margin-bottom: 64px;

    p {
      margin-bottom: 32px;
    }
  }
`

export const BoxJob = styled.a`
  width: 100%;
  padding: 32px;
  border: 1px solid #eee;
  border-radius: 4px;

  text-decoration: none;
  color: var(--black);

  display: flex;
  flex-direction: column;
  align-items: flex-start;

  transition: all 0.1s;

  p,
  h3,
  span {
    transition: all 0.1s;
  }

  strong {
    display: block;
    color: var(--orange);
    font-size: 14px;
    font-weight: 700;
    margin-bottom: 8px;
  }

  span {
    font-size: 12px;
    font-weight: bold;
    margin-top: auto;
    padding: 2px 5px;
    color: #fff;
    background-color: var(--orange);
    border-radius: 4px;
    border: 1px solid #fff;
  }

  &:hover {
    background-color: var(--orange);
    border: 1px solid var(--orange);
    color: #fff;

    strong {
      color: #fff;
    }
  }

  @media (max-width: 767px) {
    min-width: 100%;
    padding: 24px;
  }
`
